var app = angular.module("leonardo");

var PortfolioListPortfolio = function($scope, PropertyService, ngDialog, FilterService, $state, $rootScope) {
  $scope.properties = [];
  $scope.expanded = false;
  $scope.search = '';
  $scope.levels = [];

  $scope.expand = function() {
    if ($scope.expanded) {
      $scope.expanded = false;
      return;
    }
    $scope.expanded = true;
    $scope.refresh();
  };

  $scope.refresh = function() {
    var filters = {
      summary: true,
      portfolio__id: $scope.$parent.portfolio.id,
      disable_pagination: true
    };
    if(FilterService.getFilter('levels')){
     filters.levels = FilterService.getFilter('levels');
    }
    if(FilterService.getFilter('search')){
      filters.search = FilterService.getFilter('search');
    }
    if (FilterService.hasFilter('group')) {
      filters.group = FilterService.getFilter('group');
    }
    PropertyService.getlist(filters, true).then(function(list) {
      $scope.properties = list.results ? list.results : list;
    });
  };

  $scope.toggleNovice = function(property){
     var data = {
      'novice': !property.novice
    };
    property.setNovice(data).then(function() {
      $scope.refresh();
    });
  };

  $scope.goToUnits = function(property) {
    $rootScope.$broadcast('no_reset_filters:updated', true);
    FilterService.setFilter('filters', ['property_reports']);
    FilterService.setFilter('property_reports', property.id);
    $state.go('portfolios.units');
  };

  $scope.showPortfolioEditDialog = function(portfolio) {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/portfolio/add.html',
      controller: 'PortfolioAddDialog',
      data: { portfolio: portfolio , mode: 'edit'}
    }).then(function() {
      $rootScope.$broadcast('portfolio:updated');
    });
  };

  $scope.showPortfolioDeleteDialog = function(portfolio) {
    ngDialog.open({
      template: 'views/templates/dialog/portfolio/delete.html',
      controller: 'PortfolioDeleteDialog',
      data: { portfolio: portfolio }
    });
  };

  $scope.showPropertyDeleteDialog = function(property) {
    ngDialog.open({
      template: 'views/templates/dialog/property/delete.html',
      controller: 'PropertyDeleteDialog',
      data: { property: property }
    });
  };

  $scope.goToPropertyOverview = function(property) {
    FilterService.setProperty(property).then(function() {
      $state.go('property.tasks');
    });
  };

  $scope.onMovePortfolio = function(portfolio_from, property) {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/portfolio/selector_move.html',
      controller: 'PortfolioSelectorDialog',
      data: {
        account: property.account && property.account.id ? property.account.id : property.account
      }
    }).then(function(portfolio_destiny) {
      property.moveToPortfolio({portfolio: portfolio_destiny}).then(function() {
        $scope.refresh();
        $rootScope.$broadcast('property:moved', portfolio_from, portfolio_destiny);
      });
    });
  };

  $scope.$on('property:moved', function($event, portfolio_from, portfolio_destiny) {
    if (portfolio_destiny === $scope.$parent.portfolio.id) {
      $scope.refresh();
    }
  });

  $scope.$on('property:deleted', function() {
    if ($scope.expanded) {
      $scope.refresh();
    }
  });

};

app.controller('PortfolioListPortfolio', ['$scope', 'PropertyService', 'ngDialog', 'FilterService', '$state',
  '$rootScope', PortfolioListPortfolio]);
